
<template>
<div>
    <div class="row" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div id="pdf" class="col-md-12">
            <div class="row mb-2">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 d-flex justify-content-center">
                        <img src="./../../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                    </div>
                    <div class="col-md-4"></div>
            </div>
            <div class="col-md-12 row">
                <div class="col-md-6">
                    <input type="date" v-model="filters.date_1" class="form-control" @input="endofday()">
                    <input type="date" v-model="filters.date_2" class="form-control" @input="endofday()">
                </div>
                <div class="col-md-6">
                    <select v-model="filters.user" class="form-control" @input="endofday()">
                        <option value="" disabled selected>All Staff</option>
                        <option v-for="user in users" :value="user.value" :key="user.value"> {{user.text}} </option>
                    </select>
                </div>
            </div>
            <div class="col-md-12">
                <div class="well">Product Report</div>
                <table class="table table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th>Product ID</th>
                            <th>Product Name</th>
                            <th>Size/Color</th>
                            <th>Quantity</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="product in products" :key="product.id">
                            <td> {{product.id}} </td>
                            <td> {{product.productname}} </td>
                            <td> {{product.optionname}} </td>
                            <td> {{product.quantity}} </td>
                            <td> {{product.Taxable | formatAmount}} </td>
                            <td> {{product.discount | formatAmount}} </td>
                            <td> {{product.VAT | formatAmount}} </td>
                            <td> {{product.price | formatAmount}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{productTaxable | formatAmount}}  </strong></td>
                            <td> <strong> {{productDiscount | formatAmount}}  </strong></td>
                            <td> <strong> {{productVat | formatAmount}}  </strong></td>
                            <td> <strong> {{productTotal | formatAmount}}  </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="col-md-12" id="print">
                <button class="btn btn-success hidden-print" @click="print"><i class="fa fa-print"></i></button>
                <button class="btn btn-success hidden-print" @click="pdf"><i class="fa fa-file"></i></button>
                <excel
                        class = "btn btn-info"
                        :data  = "products"
                        type  = "xls"
                        name = "Product_Report.xls">
                        Download Excel
                </excel>
        </div>
    </div>

    <div class="row" v-else>
        <notfound></notfound>
    </div>

</div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import JsonExcel from 'vue-json-excel';
export default {
    components: {
        excel: JsonExcel
    },
    data(){
        return {
            products:[],
            users:[],
            drawers: '',
            filters: {
                date_1: new Date().toISOString().substr(0, 10),
                date_2: new Date().toISOString().substr(0, 10),
                user_id: this.$root.id,
                name: this.$root.staffname,
                draw: 0,
                user: ''
            },


        }
    },
    created(){
        this.endofday();
        this.getusers();
    },
    methods: {
        endofday(url = './api/Report/product') {
            this.filters.draw++
            axios
            .get(url, {params:this.filters})
            .then((result) => {
                console.log(result.data)
                this.products = result.data.product
            }).catch((err) => {
                console.log(err)
            });
        },
        getusers() {
            axios
            .get('./api/Report/users')
            .then((result) => {
                console.log(result.data)
                this.users = result.data.users
            }).catch((err) => {
                console.log(err)
            });
        },
        print(){
            var printButton = document.getElementById("print")
            printButton.style.visibility = 'hidden'
            // var divPrint = this.$refs.print

            // window.document.write(divPrint.innerHTML)
            window.print()
            window.close()
            window.location.assign('/')
            printButton.style.visibility = 'visible'
        },
        pdf() {
            var elements = document.getElementById('pdf')

            var opt = {
            margin: 15,
            filename: 'Product Report.pdf',
            image: {type: 'jpeg', quality: 0.98},
            html2canvas: {scale: 1},
            jsPDF: {
              unit: 'mm',
            //   format: [280, 350],
              orientation: 'landscape'
            }
          }
          html2pdf().set(opt).from(elements).save()
        }
    },
    computed: {
        productTaxable(){
            return this.products.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0)
        },
        productDiscount() {
            return this.products.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        productVat() {
            return this.products.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0)
        },
        productTotal() {
            return this.products.reduce((total, item) => {
                return total + Number(item.price)
            }, 0)
        }

    },
    filters:{
        formatAmount: function (value) {
            return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Report/EndDay/product.vue